import { styled } from '@mui/system';
import { Skeleton, Typography } from '@mui/material';

export const PaymentTotalBannerMain = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#FFFFFF',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',
  margin: '0px -24px',
  width: '100vw',
  marginLeft: '-50vw',
  left: '50%',
  position: 'relative',
  marginTop: '-16px',
  [theme.breakpoints.up('sm')]: {
    marginTop: '-24px',
  },
}));

export const PayAmountTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontSize: '13px',
  fontWeight: 600,
  lineHeight: '19px',
  color: '#414046',
});

export const PayAmountDiscountTypography = styled(PayAmountTypography)({
  fontWeight: 400,
  color: '#757475',
  textDecoration: 'line-through',
  marginRight: '8px',
});

export const PayAmountContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  width: '100%',
  padding: '16px 16px',
});

interface AddInsuranceTypographyProps {
  underline?: boolean;
}
export const AddInsuranceTypography = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'underline',
})<AddInsuranceTypographyProps>(({ underline }) => ({
  fontFamily: 'Poppins',
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '18px',
  color: underline ? '#0277BD' : '#414046',
  cursor: underline ? 'pointer' : 'default',
  textDecoration: underline ? 'underline' : 'none',
}));

export const AddInsuranceContainer = styled('div')({
  gap: '4px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'left',
  padding: '12px 16px',
  width: '100%',
});

interface HorizontalLineWidth {
  width?: number;
}

export const HorizontalLine = styled('div', {
  shouldForwardProp: (prop) => prop !== 'width',
})<HorizontalLineWidth>(({ width }) => ({
  width: width ? `${width}%` : '100%',
  height: '1px',
  backgroundColor: '#EAEAEA',
}));

export const AmountContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
});
export const SkeletonTotalPriceText = styled(Skeleton)({
  width: '42px',
  height: '20px',
  borderRadius: '4px',
});
